import React, { useEffect } from "react";
import Header from "../layouts/Header";
import AboutLayout from "../layouts/About";
import Footer from "../layouts/Footer";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import AboutUsStatistics from "../components/AboutUsComps/AboutUsStatistics/AboutUsStatistics";
import AboutUsDescription from "../components/AboutUsComps/AboutUsDescription/AboutUsDescription";
import FounderCeoMessage from "../components/FounderCeoMessage/FounderCeoMessage";
import usePageMeta from "../Helpers/usePageMeta";
// import BrandSection from "../components/BrandsSection/BrandSection";

const About = () => {
  usePageMeta({
    title: "About Us | TZ Creation",
    description:
      "Meet TZ Creation and see the real projects, skills and countries our founder has delivered work in -- from Canada to California to London.",
    path: "/about",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="About Us" />
      <AboutUsDescription />
      <AboutLayout aboutPage={true} />
      <FounderCeoMessage />
      <AboutUsStatistics />
      {/* <BrandSection /> */}
      <Footer />
    </>
  );
};

export default About;
